import React from 'react'
import * as R from 'ramda'

export const renderLanguage = (language) => {
  const name = R.prop('name', language)
  const native = R.compose(
    R.ifElse(
      R.anyPass([R.isEmpty, R.isNil]),
      R.always(''),
      (nativeLang) => `(${nativeLang})`,
    ),
    R.prop('nativeName'),
  )(language)
  return `${name} ${native}`
}

export const newRenderLanguage = (language) => {
  const name = R.prop('name', language)
  const native = R.prop('nativeName', language)
  return (
    <div>
      <div className="text-14">{native}</div>
      {name !== 'English' && (
        <div className="text-12 font-semibold">{name}</div>
      )}
    </div>
  )
}

const LanguageRenderItem = ({ language }) => {
  return newRenderLanguage(language)
}

export default React.memo(LanguageRenderItem)
